import { getStatus } from "./StatusAction";

const dispatchGetStatus = (dispatch: Function) => () => {
    dispatch(getStatus());
};

const StatusDispatch = {
    dispatchGetStatus
};

export default StatusDispatch